module.exports = __webpack_public_path__ + "img/ice-cream-round.5fe501ce.svg";